import { useAppBuilderContext } from 'app/app/editor/context';
import React from 'react';
import { JSONTree } from 'react-json-tree';
import { Box } from '@mui/material';

export default function StateTab() {
    const ctx = useAppBuilderContext();
    return (
        <Box sx={{ px: 2 }}>
            <JSONTree
                hideRoot
                theme={{
                    base00: '#FFF',
                }}
                labelRenderer={([key], nodeType, expanded) => (
                    <strong
                        onClick={() => {
                            // dispatch(
                            //     expanded
                            //         ? formElementCollapseProp([name, String(key)])
                            //         : formElementExpandProp([name, String(key)]),
                            // );
                        }}
                    >
                        {key}
                    </strong>
                )}
                shouldExpandNodeInitially={() => true}
                data={ctx.state}
                // shouldExpandNodeInitially={([key]) => debugExpandedProps.includes(String(key))}
            />
        </Box>
    );
}
